// extracted by css-extract-rspack-plugin
export default {"trigger":"src-components-BaseEllipsisMenu-BaseEllipsisMenu-module__trigger-W6Ylrl","dots":"src-components-BaseEllipsisMenu-BaseEllipsisMenu-module__dots-ugo7oA","menu":"src-components-BaseEllipsisMenu-BaseEllipsisMenu-module__menu-hW_SnT","item":"src-components-BaseEllipsisMenu-BaseEllipsisMenu-module__item-_GrkKa","close":"src-components-BaseEllipsisMenu-BaseEllipsisMenu-module__close-sLgGZH"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"trigger\":\"src-components-BaseEllipsisMenu-BaseEllipsisMenu-module__trigger-W6Ylrl\",\"dots\":\"src-components-BaseEllipsisMenu-BaseEllipsisMenu-module__dots-ugo7oA\",\"menu\":\"src-components-BaseEllipsisMenu-BaseEllipsisMenu-module__menu-hW_SnT\",\"item\":\"src-components-BaseEllipsisMenu-BaseEllipsisMenu-module__item-_GrkKa\",\"close\":\"src-components-BaseEllipsisMenu-BaseEllipsisMenu-module__close-sLgGZH\"}";
        // 1791855167400
        var cssReload = require("../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  